<template>
  <div>
    <!-- 评论列表-->
    <!-- <p style="font-size:0.23rem;padding:5% 3%;border-top: 1px dotted #e9e9e9;">全部评论({{guidenumber}})</p> -->
    <div class="guidebox">
      <div class="guidetext">打开猫咪APP 播放更流畅 评论更精彩</div>
      <div class="guidenbutton" @click="addopen">立即打开</div>
    </div>
  </div>
</template>

<script>
export default {
  props: { 
    guidenumber: ""
  },
  data() {
    return {

    };
  },
  methods:{
      addopen(){
          window.open("https://xmmeg0.com/")
      }
  }
};
</script>

<style scoped lang="less">
// 引导打开APP和下载APP的样式
.guidebox {
  width: 100%;
  padding: 3%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  border-top: 1px dotted #e9e9e9;
  .guidetext {
      width: 100%;
      text-align: center;
    font-size: 0.21rem;
    margin-right: 0.2rem;
  }
  .guidenbutton {
    width: 2rem;
    height: 0.5rem;
    margin-top: 0.3rem;
    font-size: 0.24rem;
    text-align: center;
    line-height: 0.5rem;
    color: #ffffff;
    border-radius: 10px;
    background: linear-gradient(to right, #fd8573, #ea4d4a);
  }
}
</style>



// WEBPACK FOOTER //
// src/common/guide.vue